import { gql, useMutation } from "@apollo/client";
import { Fade } from "@mui/material";
import logo_alt from "assets/images/comedor_alt.png";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUproColor } from "utils/colors";

function SistemaComedor() {
  let navigate = useNavigate();

  const [generateToken] = useMutation(gql`
    mutation GenerateToken {
      generateToken
    }
  `);

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    generateToken()
      .then((res) => {
        const token = res.data.generateToken;
        navigate(`/sistema-comedor?token=${token}&origin=${window.location.origin}`);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <SoftBox
      onContextMenu={handleContextMenu}
      sx={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
    >
      <Fade in={true} unmountOnExit>
        <SoftBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          sx={{
            backgroundColor: getUproColor("uproPink"),
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gap={2}
          >
            <SoftBox component="img" src={logo_alt} alt="UPrO Logo" width="15rem" />
            <SoftTypography variant="h4" align="center" color="white">
              Bienvenido a UPrO Comedor
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </Fade>
    </SoftBox>
  );
}

export default SistemaComedor;
